{
  "INBOX_MGMT": {
    "HEADER": "قنوات التواصل",
    "DESCRIPTION": "القناة هي وضع الاتصال الذي يختاره العميل للتفاعل معك. صندوق الوارد هو المكان الذي تدير فيه التفاعلات لقناة معينة. ويمكن أن تشمل الاتصالات من مصادر مختلفة مثل البريد الإلكتروني، والمحادثة الحية، ووسائط الإعلام الاجتماعية.",
    "LEARN_MORE": "تعلم المزيد عن صناديق البريد",
    "COUNT": "{n} inbox | {n} inboxes",
    "SEARCH_PLACEHOLDER": "Search inboxes...",
    "NO_RESULTS": "No inboxes found matching your search",
    "RECONNECTION_REQUIRED": "Your inbox is disconnected. You won't receive new messages until you reauthorize it.",
    "CLICK_TO_RECONNECT": "Click here to reconnect.",
    "WHATSAPP_REGISTRATION_INCOMPLETE": "Your WhatsApp Business registration isn’t complete. Please check your display name status in Meta Business Manager before reconnecting.",
    "COMPLETE_REGISTRATION": "Complete Registration",
    "LIST": {
      "404": "لا توجد صناديق وارد لقنوات تواصل مرتبطة بهذا الحساب."
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "اختر قناة",
        "BODY": "اختر الخدمة التي تود ربطها مع حسابك في Chatwoot."
      },
      "INBOX": {
        "TITLE": "إنشاء قناة تواصل",
        "BODY": "قم بالمصادقة على حسابك وإنشاء قناة التواصل."
      },
      "AGENT": {
        "TITLE": "إضافة وكلاء",
        "BODY": "إضافة وكلاء إلى صندوق الوارد الخاص بقناة التواصل التي تم إنشاؤها."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "أصبح كل شيء جاهزاً الآن!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "اسم صندوق الوارد لقناة التواصل",
        "PLACEHOLDER": "أدخل اسم صندوق الوارد الخاص بك (مثال: Acme Inc)",
        "ERROR": "الرجاء إدخال اسم صندوق الوارد صالح"
      },
      "WEBSITE_NAME": {
        "LABEL": "اسم الموقع",
        "PLACEHOLDER": "أدخل اسم موقع الويب الخاص بك (مثال: Acme Inc)"
      },
      "FB": {
        "HELP": "ملحوظة: بالمصادقة على حسابك، فنحن يمكننا فقط الوصول إلى الرسائل الواردة لصفحتك. لا يستطيع Chatwoot أبداً بأي شكل من الأشكال الوصول إلى رسائلك الخاصة في حسابك الشخصي.",
        "CHOOSE_PAGE": "اختر صفحة",
        "CHOOSE_PLACEHOLDER": "اختر صفحة من القائمة",
        "INBOX_NAME": "اسم صندوق الوارد لقناة التواصل",
        "ADD_NAME": "قم بتعيين اسم لصندوق الوارد الخاص بقناتك الجديدة",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "اختر قيمة",
        "CREATE_INBOX": "إنشاء قناة تواصل"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Continue with Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Connect your Instagram Profile",
        "HELP": "To add your Instagram profile as a channel, you need to authenticate your Instagram Profile by clicking on 'Continue with Instagram' ",
        "ERROR_MESSAGE": "There was an error connecting to Instagram, please try again",
        "ERROR_AUTH": "There was an error connecting to Instagram, please try again",
        "NEW_INBOX_SUGGESTION": "This Instagram account was previously linked to a different inbox and has now been migrated here. All new messages will appear here. The old inbox will no longer be able to send or receive messages for this account.",
        "DUPLICATE_INBOX_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. You won’t be able to send/receive Instagram messages from this inbox anymore.",
        "SETTINGS_RESTRICTED_WARNING": "Instagram is currently restricted. Some messages or actions may be delayed or unavailable while we restore full support.",
        "STATUS_LINK": "View status update"
      },
      "TIKTOK": {
        "CONTINUE_WITH_TIKTOK": "المتابعة مع تيكتوك",
        "CONNECT_YOUR_TIKTOK_PROFILE": "الاتصال بحسابك في تيكتوك",
        "HELP": "لإضافة ملفك الشخصي على TikTok كقناة، عليك مصادقة ملفك الشخصي على TikTok بالنقر على \"متابعة مع TikTok\".",
        "ERROR_MESSAGE": "حدث خطأ أثناء الاتصال بـ TikTok، يرجى المحاولة مرة أخرى",
        "ERROR_AUTH": "حدث خطأ أثناء الاتصال بـ TikTok، يرجى المحاولة مرة أخرى",
        "NORTH_AMERICA_WARNING": "TikTok connections for North American accounts are temporarily unavailable while we wait for an update from the TikTok team."
      },
      "TWITTER": {
        "HELP": "لإضافة حساب تويتر الخاص بك كقناة تواصل، تحتاج إلى مصادقة حسابك على تويتر بك بالنقر على زر \"تسجيل الدخول باستخدام تويتر\" ",
        "ERROR_MESSAGE": "حدث خطأ أثناء الاتصال بـ Twitter، الرجاء المحاولة مرة أخرى",
        "TWEETS": {
          "ENABLE": "إنشاء محادثات من التغريدات المشار إليها"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "قناة الموقع",
        "DESC": "قم بإنشاء قناة تواصل لموقع الويب الخاص بك وابدأ في استقبال الرسائل من عملائك عبر صندوق الدردشة المباشرة.",
        "LOADING_MESSAGE": "جاري إنشاء قناة تواصل للموقع",
        "CHANNEL_AVATAR": {
          "LABEL": "الصورة الرمزية للقناة"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "رابط Webhook",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "الرجاء إدخال عنوان URL صالح"
        },
        "CHANNEL_WEBHOOK_SECRET": {
          "LABEL": "Webhook Secret",
          "COPY": "Copy secret to clipboard",
          "COPY_SUCCESS": "Secret copied to clipboard",
          "TOGGLE": "Toggle secret visibility",
          "RESET_SUCCESS": "Webhook secret regenerated successfully",
          "RESET_ERROR": "Unable to regenerate webhook secret. Please try again"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "نطاق الموقع",
          "PLACEHOLDER": "أدخل نطاق موقعك الإلكتروني (مثال: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "العنوان الترحيبي",
          "PLACEHOLDER": "مرحبا بك!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "افتتاحية الترحيب",
          "PLACEHOLDER": "نحن نجعل من السهل عليك التواصل معنا. اسألنا أي شيء، أو قم بمشاركتنا ملاحظاتك."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "رسالة الترحيب التلقائية",
          "PLACEHOLDER": "يتم الرد عادة خلال بضع ساعات."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "تفعيل رسالة الترحيب التلقائية",
          "HELP_TEXT": "إرسال رسالة تحية تلقائياً عند إنشاء محادثة جديدة.",
          "ENABLED": "مفعل",
          "DISABLED": "معطّل"
        },
        "REPLY_TIME": {
          "TITLE": "حدد وقت الرد",
          "IN_A_FEW_MINUTES": "في غضون دقائق قليلة",
          "IN_A_FEW_HOURS": "في غضون ساعات قليلة",
          "IN_A_DAY": "خلال يوم",
          "HELP_TEXT": "وقت الرد هذا سيتم عرضه على أداة الدردشة المباشرة"
        },
        "WIDGET_COLOR": {
          "LABEL": "لون صندوق الدردشة",
          "PLACEHOLDER": "تحديث اللون الرئيسي لصندوق الدردشة"
        },
        "SUBMIT_BUTTON": "إنشاء قناة تواصل",
        "API": {
          "ERROR_MESSAGE": "لم نتمكن من إنشاء قناة موقع، الرجاء المحاولة مرة أخرى"
        }
      },
      "TWILIO": {
        "TITLE": "قناة Twilio SMS/WhatsApp",
        "DESC": "قم بإضافة قناة Twilio لتمكن عملائك من التواصل معك عبر الرسائل القصيرة SMS أو عبر واتساب.",
        "ACCOUNT_SID": {
          "LABEL": "معرف حساب Twilio (يعرف أيضاً بـ Account SID)",
          "PLACEHOLDER": "الرجاء إدخال معرف حساب Twilio الخاص بك (يعرف أيضاً بـ Account SID)",
          "ERROR": "هذا الحقل مطلوب"
        },
        "API_KEY": {
          "USE_API_KEY": "استخدم مفتاح مصادقة API",
          "LABEL": "مفتاح API SID",
          "PLACEHOLDER": "الرجاء إدخال معرف مفتاح واجهة برمجة التطبيقات API الخاص بك",
          "ERROR": "هذا الحقل مطلوب"
        },
        "API_KEY_SECRET": {
          "LABEL": "مفتاح سر API",
          "PLACEHOLDER": "الرجاء إدخال سر مفتاح API الخاص بك",
          "ERROR": "هذا الحقل مطلوب"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "SID خدمة المراسلة",
          "PLACEHOLDER": "الرجاء إدخال SID لخدمة مراسلة Twilio",
          "ERROR": "هذا الحقل مطلوب",
          "USE_MESSAGING_SERVICE": "استخدام خدمة مراسلة توليو"
        },
        "CHANNEL_TYPE": {
          "LABEL": "نوع القناة",
          "ERROR": "الرجاء تحديد نوع القناة"
        },
        "AUTH_TOKEN": {
          "LABEL": "رمز المصادقة Auth Token",
          "PLACEHOLDER": "الرجاء إدخال رمز مصادقة Twilio الخاص بك Auth Token",
          "ERROR": "هذا الحقل مطلوب"
        },
        "CHANNEL_NAME": {
          "LABEL": "اسم صندوق الوارد لقناة التواصل",
          "PLACEHOLDER": "الرجاء إدخال اسم القناة",
          "ERROR": "هذا الحقل مطلوب"
        },
        "PHONE_NUMBER": {
          "LABEL": "رقم الهاتف",
          "PLACEHOLDER": "الرجاء إدخال رقم الهاتف الذي سيتم إرسال الرسائل منه.",
          "ERROR": "الرجاء تقديم رقم هاتف صالح يبدأ بإشارة '+' ولا يحتوي على أي مسافات."
        },
        "API_CALLBACK": {
          "TITLE": "عنوان Callback URL",
          "SUBTITLE": "يتوجب تهيئة عنوان callback URL في إعدادات Twilio بإدخال القيمة أدناه."
        },
        "SUBMIT_BUTTON": "إنشاء قناة Twilio",
        "API": {
          "ERROR_MESSAGE": "تعذر تكوين المصادقة بواسطة بيانات الاعتماد الخاصة بحسابك على Twilio، يرجى المحاولة مرة أخرى"
        }
      },
      "SMS": {
        "TITLE": "قناة SMS",
        "DESC": "ابدأ في دعم عملائك عبر الرسائل القصيرة.",
        "PROVIDERS": {
          "LABEL": "API Provider",
          "TWILIO": "تويليو",
          "BANDWIDTH": "سعة الإنترنت"
        },
        "API": {
          "ERROR_MESSAGE": "لم نتمكن من حفظ قناة الرسائل القصيرة"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "معرف الحساب",
            "PLACEHOLDER": "الرجاء إدخال معرف حساب النطاق الترددي الخاص بك",
            "ERROR": "هذا الحقل مطلوب"
          },
          "API_KEY": {
            "LABEL": "مفتاح API",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "هذا الحقل مطلوب"
          },
          "API_SECRET": {
            "LABEL": "سرية API",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "هذا الحقل مطلوب"
          },
          "APPLICATION_ID": {
            "LABEL": "معرف التطبيق",
            "PLACEHOLDER": "الرجاء إدخال معرف تطبيق النطاق الترددي الخاص بك",
            "ERROR": "هذا الحقل مطلوب"
          },
          "INBOX_NAME": {
            "LABEL": "اسم صندوق الوارد لقناة التواصل",
            "PLACEHOLDER": "الرجاء إدخال اسم القناة",
            "ERROR": "هذا الحقل مطلوب"
          },
          "PHONE_NUMBER": {
            "LABEL": "رقم الهاتف",
            "PLACEHOLDER": "الرجاء إدخال رقم الهاتف الذي سيتم إرسال الرسائل منه.",
            "ERROR": "الرجاء تقديم رقم هاتف صالح يبدأ بإشارة '+' ولا يحتوي على أي مسافات."
          },
          "SUBMIT_BUTTON": "إنشاء قناة عرض التردد",
          "API": {
            "ERROR_MESSAGE": "تعذر تكوين المصادقة بواسطة بيانات الاعتماد الخاصة بحسابك على Twilio، يرجى المحاولة مرة أخرى"
          },
          "API_CALLBACK": {
            "TITLE": "عنوان Callback URL",
            "SUBTITLE": "يتوجب تهيئة عنوان callback URL في إعدادات Twilio بإدخال القيمة أدناه."
          }
        }
      },
      "WHATSAPP": {
        "TITLE": "قناة واتساب",
        "DESC": "ابدأ في دعم عملائك عبر واتس آب.",
        "PROVIDERS": {
          "LABEL": "API Provider",
          "WHATSAPP_EMBEDDED": "WhatsApp Business",
          "TWILIO": "تويليو",
          "WHATSAPP_CLOUD": "واتساب السحابة",
          "WHATSAPP_CLOUD_DESC": "Quick setup through Meta",
          "TWILIO_DESC": "Connect via Twilio credentials",
          "360_DIALOG": "360dialog"
        },
        "SELECT_PROVIDER": {
          "TITLE": "Select your API provider",
          "DESCRIPTION": "Choose your WhatsApp provider. You can connect directly through Meta which requires no setup, or connect through Twilio using your account credentials."
        },
        "INBOX_NAME": {
          "LABEL": "اسم صندوق الوارد لقناة التواصل",
          "PLACEHOLDER": "الرجاء إدخال اسم القناة",
          "ERROR": "هذا الحقل مطلوب"
        },
        "PHONE_NUMBER": {
          "LABEL": "رقم الهاتف",
          "PLACEHOLDER": "الرجاء إدخال رقم الهاتف الذي سيتم إرسال الرسائل منه.",
          "ERROR": "الرجاء تقديم رقم هاتف صالح يبدأ بإشارة '+' ولا يحتوي على أي مسافات."
        },
        "PHONE_NUMBER_ID": {
          "LABEL": "مُعرف رَقَم الهاتف",
          "PLACEHOLDER": "الرجاء إدخال رقم الهاتف الذي تم الحصول عليه من لوحة تحكم مطور الفيسبوك.",
          "ERROR": "الرجاء إدخال اسم صالح."
        },
        "BUSINESS_ACCOUNT_ID": {
          "LABEL": "مُعرف حساب الأعمال",
          "PLACEHOLDER": "الرجاء إدخال مُعرف حساب الأعمال الذي تم الحصول عليه من لوحة تحكم مطور الفيسبوك.",
          "ERROR": "الرجاء إدخال اسم صالح."
        },
        "WEBHOOK_VERIFY_TOKEN": {
          "LABEL": "رمز التحقق من Webhook",
          "PLACEHOLDER": "Enter a verify token which you want to configure for Facebook webhooks.",
          "ERROR": "الرجاء إدخال اسم صالح."
        },
        "API_KEY": {
          "LABEL": "مفتاح API",
          "SUBTITLE": "تكوين مفتاح واتسآب API.",
          "PLACEHOLDER": "مفتاح API",
          "ERROR": "الرجاء إدخال اسم صالح."
        },
        "API_CALLBACK": {
          "TITLE": "عنوان Callback URL",
          "SUBTITLE": "يجب عليك تكوين رابط الويب هوك و رمز التحقق في بوابة مطور الفيسبوك مع القيم الموضحة أدناه.",
          "WEBHOOK_URL": "رابط Webhook",
          "WEBHOOK_VERIFICATION_TOKEN": "رمز التحقق من Webhook"
        },
        "SUBMIT_BUTTON": "إنشاء قناة واتساب",
        "EMBEDDED_SIGNUP": {
          "TITLE": "Quick setup with Meta",
          "DESC": "Use the WhatsApp Embedded Signup flow to quickly connect new numbers. You will be redirected to Meta to log into your WhatsApp Business account. Having admin access will help make the setup smooth and easy.",
          "BENEFITS": {
            "TITLE": "Benefits of Embedded Signup:",
            "EASY_SETUP": "No manual configuration required",
            "SECURE_AUTH": "Secure OAuth based authentication",
            "AUTO_CONFIG": "Automatic webhook and phone number configuration"
          },
          "LEARN_MORE": {
            "TEXT": "To learn more about integrated signup, pricing, and limitations, visit {link}.",
            "LINK_TEXT": "this link"
          },
          "SUBMIT_BUTTON": "Connect with WhatsApp Business",
          "AUTH_PROCESSING": "Authenticating with Meta",
          "WAITING_FOR_BUSINESS_INFO": "Please complete business setup in the Meta window...",
          "PROCESSING": "Setting up your WhatsApp Business Account",
          "ENABLING_CALLING": "Enabling WhatsApp Calling on your number…",
          "LOADING_SDK": "Loading Facebook SDK...",
          "CANCELLED": "WhatsApp Signup was cancelled",
          "SUCCESS_TITLE": "WhatsApp Business Account Connected!",
          "WAITING_FOR_AUTH": "Waiting for authentication...",
          "INVALID_BUSINESS_DATA": "Invalid business data received from Facebook. Please try again.",
          "SIGNUP_ERROR": "Signup error occurred",
          "AUTH_NOT_COMPLETED": "Authentication not completed. Please restart the process.",
          "SUCCESS_FALLBACK": "WhatsApp Business Account has been successfully configured",
          "MANUAL_FALLBACK": "If your number is already connected to the WhatsApp Business Platform (API), or if you’re a tech provider onboarding your own number, please use the {link} flow",
          "MANUAL_LINK_TEXT": "manual setup flow",
          "CALLING_ENABLE_FAILED": "Your WhatsApp inbox is ready, but voice calling couldn't be turned on — this number isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then turn calling on from the inbox's Calls settings."
        },
        "API": {
          "ERROR_MESSAGE": "لم نتمكن من حفظ قناة واتساب"
        }
      },
      "VOICE": {
        "TITLE": "Voice Channel",
        "DESC": "Integrate Twilio Voice and start supporting your customers via phone calls.",
        "PHONE_NUMBER": {
          "LABEL": "رقم الهاتف",
          "PLACEHOLDER": "Enter your phone number (e.g. +1234567890)",
          "ERROR": "Please provide a valid phone number in E.164 format (e.g. +1234567890)"
        },
        "TWILIO": {
          "ACCOUNT_SID": {
            "LABEL": "معرف حساب Twilio (يعرف أيضاً بـ Account SID)",
            "PLACEHOLDER": "Enter your Twilio Account SID",
            "REQUIRED": "Account SID is required"
          },
          "AUTH_TOKEN": {
            "LABEL": "رمز المصادقة Auth Token",
            "PLACEHOLDER": "Enter your Twilio Auth Token",
            "REQUIRED": "Auth Token is required"
          },
          "API_KEY_SID": {
            "LABEL": "مفتاح API SID",
            "PLACEHOLDER": "Enter your Twilio API Key SID",
            "REQUIRED": "API Key SID is required"
          },
          "API_KEY_SECRET": {
            "LABEL": "مفتاح سر API",
            "PLACEHOLDER": "Enter your Twilio API Key Secret",
            "REQUIRED": "API Key Secret is required"
          }
        },
        "CONFIGURATION": {
          "TWILIO_VOICE_URL_TITLE": "Twilio Voice URL",
          "TWILIO_VOICE_URL_SUBTITLE": "Configure this URL as the Voice URL on your Twilio phone number and TwiML App.",
          "TWILIO_STATUS_URL_TITLE": "Twilio Status Callback URL",
          "TWILIO_STATUS_URL_SUBTITLE": "Configure this URL as the Status Callback URL on your Twilio phone number."
        },
        "SUBMIT_BUTTON": "Create Voice Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to create the voice channel"
        }
      },
      "API_CHANNEL": {
        "TITLE": "قناة API",
        "DESC": "اربط مع قناة API وابدأ في دعم عملائك.",
        "CHANNEL_NAME": {
          "LABEL": "اسم القناة",
          "PLACEHOLDER": "الرجاء إدخال اسم القناة",
          "ERROR": "هذا الحقل مطلوب"
        },
        "WEBHOOK_URL": {
          "LABEL": "رابط Webhook",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "رابط Webhook"
        },
        "SUBMIT_BUTTON": "إنشاء قناة API",
        "API": {
          "ERROR_MESSAGE": "لم نتمكن من حفظ قناة الـ api"
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "قناة البريد الالكتروني",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "اسم القناة",
          "PLACEHOLDER": "الرجاء إدخال اسم القناة",
          "ERROR": "هذا الحقل مطلوب"
        },
        "EMAIL": {
          "LABEL": "البريد الإلكتروني",
          "SUBTITLE": "البريد الإلكتروني حيث يرسل عملاؤك تذاكر الدعم",
          "PLACEHOLDER": "البريد الإلكتروني"
        },
        "SUBMIT_BUTTON": "إنشاء قناة البريد الإلكتروني",
        "API": {
          "ERROR_MESSAGE": "لم نتمكن من حفظ قناة البريد الإلكتروني"
        },
        "FINISH_MESSAGE": "بدء إعادة توجيه رسائل البريد الإلكتروني الخاصة بك إلى عنوان البريد الإلكتروني التالي.",
        "FINISH_MESSAGE_NO_FORWARDING": "تم إنشاء بريدك الإلكتروني بنجاح! تحتاج إلى تكوين بيانات اعتماد SMTP و IMAP لإرسال واستقبال رسائل البريد الإلكتروني. بدون هذه الإعدادات، لن يتم معالجة رسائل البريد الإلكتروني.",
        "FORWARDING_ADDRESS_LABEL": "إعادة توجيه رسائل البريد الإلكتروني إلى هذا العنوان",
        "CONFIGURE_SMTP_IMAP_LINK": "اضغط هنا",
        "CONFIGURE_SMTP_IMAP_TEXT": " لتهيئة إعدادات IMAP و SMTP"
      },
      "LINE_CHANNEL": {
        "TITLE": "قناة LINE",
        "DESC": "التكامل مع قناة LINE وبدء دعم عملائك.",
        "CHANNEL_NAME": {
          "LABEL": "اسم القناة",
          "PLACEHOLDER": "الرجاء إدخال اسم القناة",
          "ERROR": "هذا الحقل مطلوب"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "معرف قناة LINE",
          "PLACEHOLDER": "معرف قناة LINE"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "سرية قناة LINE",
          "PLACEHOLDER": "سرية قناة LINE"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "رمز قناة LINE",
          "PLACEHOLDER": "رمز قناة LINE"
        },
        "SUBMIT_BUTTON": "إنشاء قناة LINE",
        "API": {
          "ERROR_MESSAGE": "لم نستطع حفظ قناة LINE"
        },
        "API_CALLBACK": {
          "TITLE": "عنوان Callback URL",
          "SUBTITLE": "يجب عليك تكوين URL ويب هوك في تطبيق LINE مع عنوان URL المذكور هنا."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "قناة تيليجرام",
        "DESC": "التكامل مع قناة تيليجرام والبدء في دعم عملائك.",
        "BOT_TOKEN": {
          "LABEL": "Bot Token",
          "SUBTITLE": "تكوين رمز البوت الذي حصلت عليه من Telegram BotFather.",
          "PLACEHOLDER": "Bot Token"
        },
        "SUBMIT_BUTTON": "إنشاء قناة تيليجرام",
        "API": {
          "ERROR_MESSAGE": "لم نتمكن من حفظ قناة التلجرام"
        }
      },
      "AUTH": {
        "TITLE": "اختر قناة",
        "DESC": "يدعم أدوات الدردشة الحية، والميسنجر الفيسبوك، وملفات التويتر الشخصية، و WhatsApp، ورسائل البريد الإلكتروني، إلخ، كقنوات. إذا كنت ترغب في إنشاء قناة مخصصة، يمكنك إنشاءها باستخدام قناة API. للبدء، اختر إحدى القنوات أدناه.",
        "TITLE_NEXT": "Complete the setup",
        "TITLE_FINISH": "Voilà!",
        "CHANNEL": {
          "WEBSITE": {
            "TITLE": "الموقع الإلكتروني",
            "DESCRIPTION": "Create a live-chat widget"
          },
          "FACEBOOK": {
            "TITLE": "فيسبوك",
            "DESCRIPTION": "Connect your Facebook page"
          },
          "WHATSAPP": {
            "TITLE": "واتساب",
            "DESCRIPTION": "Support your customers on WhatsApp"
          },
          "WHATSAPP_CALL": {
            "TITLE": "WhatsApp Call",
            "DESCRIPTION": "Take voice calls on your WhatsApp number"
          },
          "EMAIL": {
            "TITLE": "البريد الإلكتروني",
            "DESCRIPTION": "Connect with Gmail, Outlook, or other providers"
          },
          "SMS": {
            "TITLE": "SMS",
            "DESCRIPTION": "Integrate SMS channel with Twilio or bandwidth"
          },
          "API": {
            "TITLE": "API",
            "DESCRIPTION": "Make a custom channel using our API"
          },
          "TELEGRAM": {
            "TITLE": "تيليجرام",
            "DESCRIPTION": "Configure Telegram channel using Bot token"
          },
          "LINE": {
            "TITLE": "Line",
            "DESCRIPTION": "Integrate your Line channel"
          },
          "INSTAGRAM": {
            "TITLE": "Instagram",
            "DESCRIPTION": "Connect your instagram account"
          },
          "TIKTOK": {
            "TITLE": "TikTok",
            "DESCRIPTION": "ربط حسابك في TikTok"
          },
          "VOICE": {
            "TITLE": "Voice",
            "DESCRIPTION": "Integrate with Twilio Voice"
          }
        }
      },
      "AGENTS": {
        "TITLE": "وكيل الدعم",
        "DESC": "هنا يمكنك إضافة موظفين لإدارة صندوق الوارد الخاص بقناة تواصلك التي تم إنشاؤها حديثاً. الموظفين الذين يتم تحديدهم هنا هم فقط من يمكنهم الوصول إلى صندوق الوارد الخاص بتلك القناة. الموظفين الذين ليسوا جزءاً من صندوق الوارد هذا لن يكونوا قادرين على رؤية أو الرد على الرسائل في قناة التواصل هذه عند تسجيل الدخول. <br> <b>ملحوظة:</b> كمسؤول، إذا كنت بحاجة إلى الوصول إلى جميع صناديق الوارد، يجب عليك إضافة نفسك كموظف لجميع صناديق الوارد الخاصة بقنوات التواصل التي تنشئها.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "اختر وكلاء لصندوق الوارد"
      },
      "DETAILS": {
        "TITLE": "تفاصيل قناة التواصل",
        "DESC": "من القائمة المنسدلة أدناه، حدد صفحة فيس بوك التي تريد ربطها بـ Chatwoot. يمكنك أيضًا تخصيص اسم لصندوق الوارد الخاص بهذه الصفحة للحصول على تجربة وصول أفضل."
      },
      "FINISH": {
        "TITLE": "تم!",
        "DESC": "لقد تم بنجاح ربط صفحة فيسبوك الخاصة بك مع Chatwoot. في المرة القادمة التي يرسل فيها العملاء رسالة إلى صفحتك، ستظهر المحادثة تلقائيًا على صندوق الوارد الخاص بك هنا.<br>نحن نزودك أيضًا بالكود النصي لصندوق دردشة الماسنجر والذي يمكنك إضافته بسهولة إلى الموقع الخاص بك لاستقبال الرسائل من الزوار كذلك. بمجرد أن يتم ذلك على موقع الويب الخاص بك، يمكن للعملاء مراسلتك من موقع الويب الخاص بك بدون الحاجة لأي أدوات خارجية وستظهر المحادثة هنا على Chatwoot.<br>رائع، أليس كذلك؟ نحن بالتأكيد نحاول أن نكون الأفضل :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "حدد مزود البريد الإلكتروني الخاص بك",
        "DESCRIPTION": "Select an email provider from the list below. If you don't see your email provider in the list, you can select the other provider option and provide the IMAP and SMTP Credentials."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Click on the Sign in with Microsoft button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "SIGN_IN": "تسجيل الدخول باستخدام Microsoft",
        "ERROR_MESSAGE": "There was an error connecting to Microsoft, please try again"
      },
      "GOOGLE": {
        "TITLE": "البريد الإلكتروني لجوجل",
        "DESCRIPTION": "انقر على تسجيل الدخول باستخدام زر جوجل للبدء. سيتم إعادة توجيهك إلى صفحة تسجيل الدخول بالبريد الإلكتروني. بمجرد قبول الأذونات المطلوبة، سيتم إعادة توجيهك إلى خطوة إنشاء علبة الوارد.",
        "SIGN_IN": "تسجيل الدخول باستخدام Google",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "ERROR_MESSAGE": "حدث خطأ أثناء الاتصال بجوجل، الرجاء المحاولة مرة أخرى"
      }
    },
    "DETAILS": {
      "LOADING_FB": "جار المصادقة والربط مع الفيسبوك...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "حدث خطأ ما، الرجاء تحديث الصفحة...",
      "ERROR_FB_UNAUTHORIZED": "You're not authorized to perform this action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "CREATING_CHANNEL": "جار إنشاء قناة التواصل...",
      "TITLE": "تهيئة إعدادات قناة التواصل",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "إضافة وكلاء",
      "ADD_AGENTS": "إضافة وكلاء إلى صندوق الوارد الخاص بالقناة..."
    },
    "FINISH": {
      "TITLE": "أصبحت قناة التواصل جاهزة الآن!",
      "MESSAGE": "يمكنك الآن التواصل مع عملائك من خلال قناتك الجديدة",
      "BUTTON_TEXT": "خذني إلى هناك",
      "MORE_SETTINGS": "المزيد من الإعدادات",
      "WEBSITE_SUCCESS": "لقد انتهيت بنجاح من إنشاء قناة دردشة مباشرة لموقعك. انسخ الرمز الموضح أدناه وقم بإضافته إلى موقع الويب الخاص بك. في المرة القادمة التي يستخدم فيها العميل الدردشة المباشرة، ستظهر المحادثة تلقائياً على صندوق الوارد الخاص بك.",
      "WHATSAPP_QR_INSTRUCTION": "Scan the QR code above to quickly test your WhatsApp inbox",
      "MESSENGER_QR_INSTRUCTION": "Scan the QR code above to quickly test your Facebook Messenger inbox",
      "TELEGRAM_QR_INSTRUCTION": "Scan the QR code above to quickly test your Telegram inbox"
    },
    "REAUTH": "إعادة التصريح",
    "VIEW": "عرض",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "تم تحديث إعدادات قناة التواصل بنجاح",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "تم تحديث إعدادات الإسناد التلقائي بنجاح",
        "ERROR_MESSAGE": "تعذر تحديث إعدادات صندوق الوارد. الرجاء المحاولة مرة أخرى لاحقاً."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "مفعل",
        "DISABLED": "معطّل"
      },
      "ENABLE_CSAT": {
        "ENABLED": "مفعل",
        "DISABLED": "معطّل"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sender name",
        "SUB_TEXT": "حدد الاسم الذي يظهر للعميل الخاص بك عندما يتلقى رسائل البريد الإلكتروني من الوكلاء الخاصين.",
        "FOR_EG": "For eg:",
        "FRIENDLY": {
          "TITLE": "Friendly",
          "FROM": "من",
          "SUBTITLE": "يضاف اسم الوكيل الذي أرسل الرد باسم المرسل لجعله صديقا."
        },
        "PROFESSIONAL": {
          "TITLE": "Professional",
          "SUBTITLE": "Use only the configured business name as the sender name in the email header."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "Configure your business name",
          "PLACEHOLDER": "Enter your business name",
          "SAVE_BUTTON_TEXT": "حفظ"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "مفعل",
        "DISABLED": "معطّل"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "مفعل",
        "DISABLED": "معطّل"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Reopen same conversation",
        "DISABLED": "Create new conversations",
        "ENABLED_DESCRIPTION": "When a contact messages again, the previous conversation will be reopened.",
        "DISABLED_DESCRIPTION": "A new conversation will be created each time after the previous one is resolved."
      },
      "ENABLE_HMAC": {
        "LABEL": "تفعيل"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "حذف",
      "AVATAR_DELETE_BUTTON_TEXT": "حذف الصورة الرمزية",
      "CONFIRM": {
        "TITLE": "تأكيد الحذف",
        "MESSAGE": "هل أنت متأكد من الحذف ",
        "PLACE_HOLDER": "الرجاء كتابة {inboxName} للتأكيد",
        "YES": "نعم، احذف ",
        "NO": "لا، احتفظ "
      },
      "API": {
        "SUCCESS_MESSAGE": "تم حذف قناة التواصل بنجاح",
        "ERROR_MESSAGE": "تعذر حذف قناة التواصل. الرجاء المحاولة مرة أخرى لاحقاً.",
        "AVATAR_SUCCESS_MESSAGE": "تم حذف الصورة الرمزية لصندوق الوارد بنجاح",
        "AVATAR_ERROR_MESSAGE": "لا يمكن حذف الصورة الرمزية لصندوق الوارد. الرجاء المحاولة مرة أخرى لاحقاً."
      }
    },
    "TABS": {
      "SETTINGS": "الإعدادات",
      "COLLABORATORS": "المتعاونون",
      "CONFIGURATION": "الإعدادات",
      "CAMPAIGN": "الحملات",
      "PRE_CHAT_FORM": "نموذج ما قبل الدردشة",
      "BUSINESS_HOURS": "ساعات العمل",
      "WIDGET_BUILDER": "منشئ اللايف شات",
      "BOT_CONFIGURATION": "اعدادات البوت",
      "ACCOUNT_HEALTH": "Account Health",
      "CSAT": "تقييم رضاء العملاء",
      "VOICE": "Voice",
      "CALLS": "Calls"
    },
    "VOICE_CONFIGURATION": {
      "ENABLE_VOICE": {
        "LABEL": "Enable Voice Calling",
        "DESCRIPTION": "Enable voice calling on this inbox. Agents will be able to make and receive phone calls."
      },
      "CREDENTIALS": {
        "DESCRIPTION": "Voice calling requires Twilio API Key credentials. These are used to generate tokens for agent voice connections."
      },
      "INBOUND": {
        "LABEL": "Allow incoming calls",
        "DESCRIPTION": "Let customers call this number. When turned off, incoming calls are declined automatically — agents aren't notified and no conversation is created. Agents can still place outgoing calls."
      }
    },
    "WHATSAPP_CALLING": {
      "ENABLE": {
        "LABEL": "Enable WhatsApp Calling",
        "DESCRIPTION": "Allow agents to receive and place WhatsApp Cloud calls on this inbox. Customers can call this business number directly from WhatsApp."
      },
      "ENABLE_FAILED": "Voice calling couldn't be turned on for this number — it isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then try again.",
      "PHONE_NUMBER": {
        "LABEL": "Business phone number",
        "HELP_TEXT": "WhatsApp number that customers will call."
      },
      "HOW_IT_WORKS": {
        "LABEL": "How it works",
        "DESCRIPTION": "Calls are placed peer-to-peer between the agent's browser and Meta — no extra credentials are required. Make sure the agent's browser has microphone permission for this site."
      },
      "PERMISSION_REQUEST_BODY": {
        "LABEL": "Call permission request message",
        "HELP_TEXT": "Shown to the contact when they haven't yet consented to receive calls. Leave blank to use the default.",
        "PLACEHOLDER": "We would like to call you regarding your conversation."
      }
    },
    "CHANNEL_PREFERENCES": "Channel Preferences",
    "WIDGET_FEATURES": "Widget features",
    "ACCOUNT_HEALTH": {
      "TITLE": "Manage your WhatsApp account",
      "DESCRIPTION": "Review your WhatsApp account status, messaging limits, and quality. Update settings or resolve issues if needed",
      "GO_TO_SETTINGS": "Go to Meta Business Manager",
      "NO_DATA": "Health data is not available",
      "FIELDS": {
        "DISPLAY_PHONE_NUMBER": {
          "LABEL": "Display phone number",
          "TOOLTIP": "Phone number displayed to customers"
        },
        "VERIFIED_NAME": {
          "LABEL": "Business name",
          "TOOLTIP": "Business name verified by WhatsApp"
        },
        "DISPLAY_NAME_STATUS": {
          "LABEL": "Display name status",
          "TOOLTIP": "Status of your business name verification"
        },
        "QUALITY_RATING": {
          "LABEL": "Quality rating",
          "TOOLTIP": "WhatsApp quality rating for your account"
        },
        "MESSAGING_LIMIT_TIER": {
          "LABEL": "Messaging limit tier",
          "TOOLTIP": "Daily messaging limit for your account"
        },
        "ACCOUNT_MODE": {
          "LABEL": "Account mode",
          "TOOLTIP": "Current operating mode of your WhatsApp account"
        }
      },
      "VALUES": {
        "TIERS": {
          "TIER_250": "250 customers per 24h",
          "TIER_1000": "1K customers per 24h",
          "TIER_1K": "1K customers per 24h",
          "TIER_10K": "10K customers per 24h",
          "TIER_100K": "100K customers per 24h",
          "TIER_UNLIMITED": "Unlimited customers per 24h",
          "UNKNOWN": "Rating not available"
        },
        "STATUSES": {
          "APPROVED": "Approved",
          "PENDING_REVIEW": "Pending Review",
          "AVAILABLE_WITHOUT_REVIEW": "Available Without Review",
          "REJECTED": "Rejected",
          "DECLINED": "Declined",
          "NON_EXISTS": "Non exists"
        },
        "MODES": {
          "SANDBOX": "Sandbox",
          "LIVE": "مباشر"
        }
      },
      "WEBHOOK": {
        "TITLE": "Webhook Configuration",
        "DESCRIPTION": "Webhook URL is required for your WhatsApp Business Account to receive messages from customers",
        "ACTION_REQUIRED": "Webhook not configured",
        "REGISTER_BUTTON": "Register Webhook",
        "REGISTER_SUCCESS": "Webhook registered successfully",
        "REGISTER_ERROR": "Failed to register webhook. Please try again.",
        "CONFIGURED_SUCCESS": "Webhook configured successfully",
        "URL_MISMATCH": "Webhook URL mismatch"
      }
    },
    "SETTINGS": "الإعدادات",
    "FEATURES": {
      "LABEL": "الخصائص",
      "DISPLAY_FILE_PICKER": "عرض أداة انتقاء الملفات في الـ widget",
      "DISPLAY_EMOJI_PICKER": "عرض منتقي الرموز التعبيرية على الـ widget",
      "ALLOW_END_CONVERSATION": "السماح للمستخدمين بإنهاء المحادثة من عنصر واجهة المستخدم",
      "USE_INBOX_AVATAR_FOR_BOT": "Use inbox name and avatar for the bot"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "كود \"الماسنجر\"",
      "MESSENGER_SUB_HEAD": "ضع هذا الكود داخل وسم الـ body في موقعك",
      "ALLOWED_DOMAINS": {
        "TITLE": "Allowed Domains",
        "DESCRIPTION": "Restrict which websites can embed your chat widget. For security, only add domains you own and trust. Add one or more domains separated by commas. Leave blank to allow all domains (not recommended for production).",
        "PLACEHOLDER": "example.com, www.example.com, app.example.com"
      },
      "ALLOW_MOBILE_WEBVIEW": {
        "LABEL": "Enable widget in mobile apps",
        "SUBTITLE": "حدد هذا الخيار إذا كنت تقوم بتضمين الأداة في تطبيقات iOS أو Android. لا ترسل تطبيقات الجوال معلومات النطاق، لذا سيتم حظرها بسبب قيود النطاق ما لم يتم تفعيل هذا الخيار."
      },
      "IDENTITY_VALIDATION": {
        "TITLE": "Identity Validation",
        "DESCRIPTION": "Verify user authenticity by generating secure tokens. This prevents unauthorized users from impersonating others in your chat.",
        "SECRET_KEY": "Secret Key",
        "VIEW_DOCS": "View documentation",
        "REQUIRE_LABEL": "Require identity validation for all conversations",
        "REQUIRE_DESCRIPTION": "When enabled, users must provide a valid identity token to start conversations. Requests without valid tokens will be rejected."
      },
      "INBOX_AGENTS": "وكيل الدعم",
      "INBOX_AGENTS_SUB_TEXT": "إضافة أو إزالة وكلاء من صندوق الوارد هذا",
      "AGENT_ASSIGNMENT": "تعيين المحادثة",
      "AGENT_ASSIGNMENT_SUB_TEXT": "تحديث إعدادات إسناد المحادثات",
      "UPDATE": "تحديث",
      "ENABLE_EMAIL_COLLECT_BOX": "تفعيل صندوق جمع البريد الإلكتروني",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "تمكين أو تعطيل مربع جمع البريد الإلكتروني في محادثة جديدة",
      "AUTO_ASSIGNMENT": "تفعيل الإسناد التلقائي",
      "SENDER_NAME_SECTION": "تمكين اسم الوكيل في البريد الإلكتروني",
      "SENDER_NAME_SECTION_TEXT": "تمكين/تعطيل إظهار اسم الوكيل في البريد الإلكتروني، إذا تم تعطيله فسيظهر اسم المنشأة",
      "ENABLE_CONTINUITY_VIA_EMAIL": "تمكين استمرارية المحادثة عبر البريد الإلكتروني",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "المحادثات ستستمر عبر البريد الإلكتروني إذا كان عنوان البريد الإلكتروني لجهة الاتصال متاحاً.",
      "ENABLE_CONTINUITY_VIA_EMAIL_DISABLED_TEXT": "هذه الميزة متوفرة في الخطة المدفوعة. قم بالترقية لتفعيل استمرارية المحادثة عبر البريد الإلكتروني.",
      "LOCK_TO_SINGLE_CONVERSATION": "Conversation Routing",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Configure conversation creation for existing contacts",
      "INBOX_UPDATE_TITLE": "إعدادات قناة التواصل",
      "INBOX_UPDATE_SUB_TEXT": "تحديث إعدادات قناة التواصل",
      "AUTO_ASSIGNMENT_SUB_TEXT": "تمكين أو تعطيل الإسناد التلقائي للمحادثات الجديدة إلى الموظفين المضافين إلى قناة التواصل هذه.",
      "HMAC_VERIFICATION": "التحقق من هوية المستخدم",
      "HMAC_DESCRIPTION": "من أجل التحقق من هوية المستخدم، يمكنك تمرير 'IDer_hash` لكل مستخدم. يمكنك إنشاء تجزئة HMAC sha256 باستخدام \"المعرف\" مع المفتاح المعروض هنا.",
      "HMAC_LINK_TO_DOCS": "You can read more here.",
      "HMAC_MANDATORY_VERIFICATION": "فرض التحقق من هوية المستخدم",
      "HMAC_MANDATORY_DESCRIPTION": "في حالة التمكين، سيتم رفض الطلبات المفقودة 'IDer_hash'.",
      "INBOX_IDENTIFIER": "معرف صندوق الوارد",
      "INBOX_IDENTIFIER_SUB_TEXT": "استخدم رمز 'inbox_identifier' المعروض هنا للمصادقة على عملاء API الخاص بك.",
      "FORWARD_EMAIL_TITLE": "إعادة التوجيه إلى البريد الإلكتروني",
      "FORWARD_EMAIL_SUB_TEXT": "بدء إعادة توجيه رسائل البريد الإلكتروني الخاصة بك إلى عنوان البريد الإلكتروني التالي.",
      "FORWARD_EMAIL_NOT_CONFIGURED": "Forwarding emails to your inbox is currently disabled on this installation. To use this feature, it must be enabled by your administrator. Please get in touch with them to proceed.",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "السماح بالرسائل بعد حل المحادثة",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "السماح للمستخدمين النهائيين بإرسال رسائل حتى بعد تسوية المحادثة.",
      "WHATSAPP_SECTION_SUBHEADER": "يتم استخدام مفتاح API هذا للتكامل مع واتسب APIs.",
      "WHATSAPP_SECTION_UPDATE_SUBHEADER": "Enter the new API key to be used for the integration with the WhatsApp APIs.",
      "WHATSAPP_SECTION_TITLE": "مفتاح API",
      "WHATSAPP_SECTION_UPDATE_TITLE": "Update API Key",
      "WHATSAPP_SECTION_UPDATE_PLACEHOLDER": "Enter the new API Key here",
      "WHATSAPP_SECTION_UPDATE_BUTTON": "تحديث",
      "WHATSAPP_EMBEDDED_SIGNUP_TITLE": "WhatsApp Embedded Signup",
      "WHATSAPP_EMBEDDED_SIGNUP_SUBHEADER": "This inbox is connected through WhatsApp embedded signup.",
      "WHATSAPP_EMBEDDED_SIGNUP_DESCRIPTION": "You can reconfigure this inbox to update your WhatsApp Business settings.",
      "WHATSAPP_RECONFIGURE_BUTTON": "Reconfigure",
      "WHATSAPP_MANUAL_TRANSFER_TITLE": "Switch to Manual Setup",
      "WHATSAPP_MANUAL_TRANSFER_SUBHEADER": "This inbox was connected through WhatsApp embedded signup, which is no longer supported. Enter the WhatsApp Cloud API credentials from your own Meta app to switch this inbox to a manual setup. Configure the webhook in your Meta app using the verification token above before switching.",
      "WHATSAPP_MANUAL_TRANSFER_PHONE_NUMBER_ID_LABEL": "Phone Number ID",
      "WHATSAPP_MANUAL_TRANSFER_BUSINESS_ACCOUNT_ID_LABEL": "مُعرف حساب الأعمال",
      "WHATSAPP_MANUAL_TRANSFER_API_KEY_LABEL": "مفتاح API",
      "WHATSAPP_MANUAL_TRANSFER_API_KEY_PLACEHOLDER": "Enter a permanent access token from your Meta app",
      "WHATSAPP_MANUAL_TRANSFER_BUTTON": "Switch to Manual Setup",
      "WHATSAPP_MANUAL_TRANSFER_SUCCESS": "Inbox switched to manual setup successfully.",
      "WHATSAPP_MANUAL_TRANSFER_ERROR": "Could not switch to manual setup. Please verify the credentials and try again.",
      "WHATSAPP_CONNECT_TITLE": "Connect to WhatsApp Business",
      "WHATSAPP_CONNECT_SUBHEADER": "Upgrade to WhatsApp embedded signup for easier management.",
      "WHATSAPP_CONNECT_DESCRIPTION": "Connect this inbox to WhatsApp Business for enhanced features and easier management.",
      "WHATSAPP_CONNECT_BUTTON": "ربط الاتصال",
      "WHATSAPP_CONNECT_SUCCESS": "Successfully connected to WhatsApp Business!",
      "WHATSAPP_CONNECT_ERROR": "Failed to connect to WhatsApp Business. Please try again.",
      "WHATSAPP_RECONFIGURE_SUCCESS": "Successfully reconfigured WhatsApp Business!",
      "WHATSAPP_RECONFIGURE_ERROR": "Failed to reconfigure WhatsApp Business. Please try again.",
      "WHATSAPP_APP_ID_MISSING": "WhatsApp App ID is not configured. Please contact your administrator.",
      "WHATSAPP_CONFIG_ID_MISSING": "WhatsApp Configuration ID is not configured. Please contact your administrator.",
      "WHATSAPP_LOGIN_CANCELLED": "WhatsApp login was cancelled. Please try again.",
      "WHATSAPP_WEBHOOK_TITLE": "رمز التحقق من Webhook",
      "WHATSAPP_WEBHOOK_SUBHEADER": "This token is used to verify the authenticity of the webhook endpoint.",
      "WHATSAPP_TEMPLATES_SYNC_TITLE": "Sync Templates",
      "WHATSAPP_TEMPLATES_SYNC_SUBHEADER": "Manually sync message templates from WhatsApp to update your available templates.",
      "WHATSAPP_TEMPLATES_SYNC_BUTTON": "Sync Templates",
      "WHATSAPP_TEMPLATES_SYNC_SUCCESS": "Templates sync initiated successfully. It may take a couple of minutes to update.",
      "WHATSAPP_MANUAL_MIGRATION": {
        "BANNER": {
          "TITLE": "Manual setup recommended",
          "DESCRIPTION": "This inbox connects through the shared Meta app used for embedded signup, which recent Meta restrictions have affected. To avoid similar issues in the future, we recommend reconnecting it with your own Meta app.",
          "START": "Start manual migration",
          "GUIDE": "View guide"
        },
        "DIALOG": {
          "EYEBROW": "WhatsApp manual migration",
          "TITLE": "Reconnect WhatsApp inbox",
          "CLOSE": "أغلق",
          "ACTION_REQUIRED_TITLE": "Reconnect with your own Meta app",
          "ACTION_REQUIRED_DESCRIPTION": "Inboxes connected through your own Meta app are not affected by restrictions on the shared embedded signup app. This guided flow updates the WhatsApp API connection without creating a new inbox.",
          "GUIDE_LINK": "Open the manual setup guide",
          "PRESERVED_TITLE": "Preserved",
          "PRESERVED_DESCRIPTION": "Conversations, contacts, collaborators, routing, business hours, and inbox settings.",
          "UPDATED_TITLE": "Updated",
          "UPDATED_DESCRIPTION": "WABA ID, phone number ID, access token, and webhook configuration.",
          "WABA_ID": "WABA ID",
          "WABA_PLACEHOLDER": "Enter WABA ID",
          "WABA_HELP": "The WhatsApp Business Account that owns this phone number.",
          "PHONE_NUMBER_ID": "Phone Number ID",
          "PHONE_NUMBER_PLACEHOLDER": "Enter Phone Number ID",
          "PHONE_NUMBER_HELP": "Meta's unique ID for the WhatsApp number connected to this inbox.",
          "DISPLAY_PHONE_NUMBER": "Display phone number",
          "DISPLAY_PHONE_NUMBER_PLACEHOLDER": "Enter display phone number",
          "DISPLAY_PHONE_NUMBER_HELP": "The customer-facing WhatsApp number. This cannot be changed during migration.",
          "ACCESS_TOKEN": "Permanent access token or system user token",
          "ACCESS_TOKEN_PLACEHOLDER": "Paste access token",
          "TOKEN_HELP_PREFIX": "The token must include",
          "TOKEN_HELP_MIDDLE": "إضافة",
          "TOKEN_HELP_SUFFIX": "for template sync and template management.",
          "MESSAGING_PERMISSION": "whatsapp_business_messaging.",
          "MANAGEMENT_PERMISSION": "whatsapp_business_management",
          "REVIEW_TITLE": "Review before reconnecting",
          "INBOX": "صندوق الوارد",
          "PHONE_NUMBER": "رقم الهاتف",
          "NOT_ENTERED": "Not entered",
          "VERIFY_NOTICE": "Chatwoot will verify these credentials with Meta before applying any changes. If verification fails, the current configuration is left untouched.",
          "BACK": "العودة",
          "CANCEL": "إلغاء",
          "CONTINUE": "Continue",
          "REVIEW_MIGRATION": "Review migration",
          "RECONNECT": "Reconnect WhatsApp inbox"
        },
        "STEPS": {
          "BEFORE_YOU_START": {
            "TITLE": "Before you start",
            "DESCRIPTION": "This reconnects the WhatsApp API details for this inbox. Conversations, collaborators, routing, business hours, CSAT, and bot settings will be preserved."
          },
          "BUSINESS_DETAILS": {
            "TITLE": "Business details",
            "DESCRIPTION": "Enter the WhatsApp assets from the customer Meta Business account."
          },
          "ACCESS_TOKEN": {
            "TITLE": "Access token",
            "DESCRIPTION": "Paste a permanent access token or system user token with WhatsApp permissions."
          },
          "REVIEW_MIGRATION": {
            "TITLE": "Review migration",
            "DESCRIPTION": "Confirm the connection details before reconnecting this inbox. Chatwoot will verify the token, WABA, and phone number with Meta before applying changes."
          }
        }
      },
      "WHATSAPP_CALLING_ENABLED": {
        "LABEL": "Enable voice calling",
        "DESCRIPTION": "Allow agents to start and receive WhatsApp voice calls on this inbox. Available only on embedded-signup WhatsApp Cloud channels with calling permission granted by Meta."
      },
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Update Pre Chat Form Settings"
    },
    "HELP_CENTER": {
      "LABEL": "مركز المساعدة",
      "PLACEHOLDER": "Select Help Center",
      "SELECT_PLACEHOLDER": "Select Help Center",
      "NONE": "لا شيء",
      "REMOVE": "Remove Help Center",
      "SUB_TEXT": "Attach a Help Center with the inbox"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "حد الإسناد التلقائي",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "الرجاء إدخال قيمة أكبر من 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "تحديد الحد الأقصى لعدد المحادثات من علبة الوارد هذه التي يمكن تعيينها تلقائياً إلى وكيل"
    },
    "ASSIGNMENT": {
      "TITLE": "تعيين المحادثة",
      "DESCRIPTION": "تعيين المحادثات الواردة تلقائياً إلى الوكلاء المتاحين استناداً إلى سياسات التعيين",
      "ENABLE_AUTO_ASSIGNMENT": "تمكين تعيين المحادثة تلقائياً",
      "DEFAULT_RULES_TITLE": "قواعد التعيين الافتراضية",
      "DEFAULT_RULES_DESCRIPTION": "استخدام سلوك التعيين الافتراضي لجميع المحادثات",
      "DEFAULT_RULE_1": "المحادثات التي تم إنشاؤها أولاً",
      "DEFAULT_RULE_2": "توزيع الجدولة الدائرية (Round robin)",
      "CUSTOMIZE_WITH_POLICY": "Customize with assignment policy",
      "USING_POLICY": "استخدام سياسة التعيين المخصصة لهذه القناة",
      "CUSTOMIZE_POLICY": "التخصيص وفقًا لسياسة التعيين",
      "DELETE_POLICY": "حذف سياسة",
      "POLICY_LABEL": "سياسة التعيين",
      "ASSIGNMENT_ORDER_LABEL": "ترتيب التعيين",
      "ASSIGNMENT_METHOD_LABEL": "طريقة التعيين",
      "POLICY_STATUS": {
        "ACTIVE": "مفعل",
        "INACTIVE": "غير نشط"
      },
      "PRIORITY": {
        "EARLIEST_CREATED": "تم إنشاؤها في وقت سابق",
        "LONGEST_WAITING": "أطول انتظار"
      },
      "METHOD": {
        "ROUND_ROBIN": "Round robin",
        "BALANCED": "تعيين متوازن"
      },
      "UPGRADE_PROMPT": "سياسة التعيين المخصصة متاحى في الخطة (Business) ",
      "UPGRADE_TO_BUSINESS": "الترقية إلى (Business)",
      "DEFAULT_POLICY_LINKED": "السياسة الافتراضية المرتبطة",
      "DEFAULT_POLICY_DESCRIPTION": "ربط سياسة تعيين مخصصة لتخصيص كيفية تعيين المحادثات إلى الوكلاء في هذه القناه",
      "LINK_EXISTING_POLICY": "ربط السياسة الحالية",
      "CREATE_NEW_POLICY": "إنشاء سياسة جديدة",
      "NO_POLICIES": "لم يتم العثور على سياسات التعيين",
      "VIEW_ALL_POLICIES": "عرض جميع السياسات",
      "CURRENT_BEHAVIOR": "حاليا يستخدم سلوك التعيين الافتراضي:",
      "LINK_SUCCESS": "تم ربط سياسة التعيين بنجاح",
      "LINK_ERROR": "فشل في ربط سياسة التعيين"
    },
    "ASSIGNMENT_POLICY": {
      "DELETE_CONFIRM_TITLE": "حذف سياسة التعيين؟",
      "DELETE_CONFIRM_MESSAGE": "هل أنت متأكد من أنك تريد إزالة سياسة التعيين هذه من صندوق الوارد هذا؟ صندوق الوارد سوف يعود إلى قواعد التعيين الافتراضية.",
      "CANCEL": "إلغاء",
      "CONFIRM_DELETE": "حذف",
      "DELETE_SUCCESS": "تمت إزالة سياسة التعيين بنجاح",
      "DELETE_ERROR": "فشل في إزالة سياسة التعيين"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "إعادة التصريح",
      "SUBTITLE": "انتهت صلاحية اتصال الفيسبوك الخاص بك، يرجى إعادة الاتصال بصفحة الفيسبوك الخاصة بك لمواصلة الخدمات",
      "MESSAGE_SUCCESS": "تمت إعادة الاتصال بنجاح",
      "MESSAGE_ERROR": "حدث خطأ، الرجاء المحاولة مرة أخرى"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "نماذج ما قبل الدردشة تمكنك من التقاط معلومات المستخدم قبل بدء المحادثة معك.",
      "SET_FIELDS": "حقول نموذج الدردشة السابقة",
      "SET_FIELDS_HEADER": {
        "FIELDS": "الحقول",
        "LABEL": "الوسم",
        "PLACE_HOLDER": "المحتوى",
        "KEY": "المفتاح",
        "TYPE": "النوع",
        "REQUIRED": "مطلوب"
      },
      "ENABLE": {
        "LABEL": "تمكين نموذج الدردشة السابقة",
        "OPTIONS": {
          "ENABLED": "نعم",
          "DISABLED": "لا"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "رسالة ما قبل المحادثة",
        "PLACEHOLDER": "ستكون هذه الرسالة مرئية للمستخدمين مع النموذج"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "يجب على الزوار تقديم اسمهم وعنوان بريدهم الإلكتروني قبل بدء المحادثة"
      }
    },
    "CSAT": {
      "TITLE": "تمكين تقييم خدمة العملاء",
      "SUBTITLE": "Automatically trigger CSAT surveys at the end of conversations to understand how customers feel about their support experience. Track satisfaction trends and identify areas for improvement over time.",
      "DISPLAY_TYPE": {
        "LABEL": "Display type"
      },
      "MESSAGE": {
        "LABEL": "رسالة",
        "PLACEHOLDER": "Please enter a message to show users with the form"
      },
      "BUTTON_TEXT": {
        "LABEL": "نص الزر",
        "PLACEHOLDER": "يرجى تقييمنا"
      },
      "LANGUAGE": {
        "LABEL": "اللغة",
        "PLACEHOLDER": "اختر لغة القالب"
      },
      "MESSAGE_PREVIEW": {
        "LABEL": "معاينة الرسالة",
        "TOOLTIP": "قد يختلف هذا قليلاً عند تقديمه على منصة WhatsApp."
      },
      "TEMPLATE_STATUS": {
        "APPROVED": "معتمد بواسطة WhatsApp",
        "PENDING": "في انتظار موافقة WhatsApp",
        "REJECTED": "Meta رفضت القالب",
        "DEFAULT": "يحتاج موافقة WhatsApp",
        "NOT_FOUND": "هذا القالب غير موجود في منصة ميتا."
      },
      "TEMPLATE_CREATION": {
        "SUCCESS_MESSAGE": "تم إنشاء قالب WhatsApp بنجاح وإرساله للموافقة عليه",
        "ERROR_MESSAGE": "فشل إنشاء قالب WhatsApp"
      },
      "TEMPLATE_UPDATE_DIALOG": {
        "TITLE": "تعديل تفاصيل الاستبيان",
        "DESCRIPTION": "سوف نقوم بحذف القالب السابق ونقوم بإنشاء قالب جديد حيث سيتم إرساله مرة أخرى للاعتماد من قبل Whatsapp",
        "CONFIRM": "إنشاء قالب جديد",
        "CANCEL": "العودة للخلف"
      },
      "UTILITY_ANALYZER": {
        "ACTION": "Check utility fit",
        "HELPER_NOTE": "Check this message before submission to improve Utility fit. The system creates a dedicated CSAT template with buttons for reporting and submits it as Utility; Meta may still reclassify it as Marketing based on content.",
        "RESULT_LABEL": "Meta category prediction",
        "GUIDANCE_NOTE": "This is a guidance check, not a guarantee of Meta approval.",
        "SUGGESTION_LABEL": "Suggested utility-safe rewrite",
        "APPLY": "Use this rewrite",
        "ERROR_MESSAGE": "Couldn't analyze the message. Please try again.",
        "CLASSIFICATION": {
          "LIKELY_UTILITY": "Likely Utility",
          "LIKELY_MARKETING": "Likely Marketing",
          "UNCLEAR": "Needs clarification"
        }
      },
      "SURVEY_RULE": {
        "LABEL": "Survey rule",
        "DESCRIPTION_PREFIX": "Send the survey if the conversation",
        "DESCRIPTION_SUFFIX": "any of the labels",
        "OPERATOR": {
          "CONTAINS": "يحتوي",
          "DOES_NOT_CONTAINS": "لا يحتوي"
        },
        "SELECT_PLACEHOLDER": "select labels"
      },
      "NOTE": "Note: CSAT surveys are sent only once per conversation",
      "WHATSAPP_NOTE": "Note: When you save, the system creates a dedicated CSAT template in WhatsApp (used to capture rating and feedback in reports) and submits it as Utility for approval. Meta may still classify it as Marketing based on content. After approval, surveys are sent only once per conversation as per the survey rule.",
      "API": {
        "SUCCESS_MESSAGE": "CSAT settings updated successfully",
        "ERROR_MESSAGE": "We couldn't update CSAT settings. Please try again later."
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "قم بتعيين توافرك",
      "SUBTITLE": "تعيين توافرك على أداة الدردشة المباشرة الخاصة بك",
      "WEEKLY_TITLE": "تعيين ساعات العمل الأسبوعية الخاصة بك",
      "TIMEZONE_LABEL": "اختر المنطقة الزمنية",
      "UPDATE": "تحديث إعدادات ساعات العمل",
      "TOGGLE_AVAILABILITY": "تمكين توافر العمل لهذا البريد الوارد",
      "UNAVAILABLE_MESSAGE_LABEL": "رسالة غير متاح للزائرين",
      "TOGGLE_HELP": "تمكين توفر العمل سيظهر الساعات المتاحة على أداة الدردشة المباشرة حتى لو كان جميع الوكلاء غير متصلين بالإنترنت. خارج الساعات المتاحة يمكن تحذير الزوار برسالة ونموذج ما قبل الدردشة.",
      "DAY": {
        "DAY": "اليوم",
        "AVAILABILITY": "التوفر",
        "HOURS": "Hours",
        "ENABLE": "تمكين التوفر لهذا اليوم",
        "UNAVAILABLE": "غير متوفر",
        "VALIDATION_ERROR": "يجب أن يكون وقت البدء قبل وقت الإغلاق.",
        "CHOOSE": "اختر"
      },
      "ALL_DAY": "جميع الأيام"
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "تعيين تفاصيل IMAP الخاصة بك",
      "NOTE_TEXT": "لتمكين SMTP ، الرجاء تكوين IMAP.",
      "UPDATE": "تحديث الإعدادات",
      "TOGGLE_AVAILABILITY": "تمكين تكوين IMAP لهذا البريد الوارد",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "تم تحديث إعدادات IMAP بنجاح",
        "ERROR_MESSAGE": "غير قادر على تحديث إعدادات IMAP"
      },
      "ADDRESS": {
        "LABEL": "العنوان",
        "PLACE_HOLDER": "العنوان (على سبيل المثال: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "المنفذ",
        "PLACE_HOLDER": "المنفذ"
      },
      "LOGIN": {
        "LABEL": "تسجيل الدخول",
        "PLACE_HOLDER": "تسجيل الدخول"
      },
      "PASSWORD": {
        "LABEL": "كلمة المرور",
        "PLACE_HOLDER": "كلمة المرور"
      },
      "ENABLE_SSL": "تمكين SSL",
      "AUTH_MECHANISM": "المصادقة"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Reauthorize your MICROSOFT account"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "تعيين تفاصيل IMAP الخاصة بك",
      "UPDATE": "تحديث إعدادات SMTP",
      "TOGGLE_AVAILABILITY": "تمكين تكوين IMAP لهذا البريد الوارد",
      "TOGGLE_HELP": "تمكين SMTP سيساعد المستخدم على إرسال البريد الإلكتروني",
      "EDIT": {
        "SUCCESS_MESSAGE": "تم تحديث إعدادات SMTP بنجاح",
        "ERROR_MESSAGE": "غير قادر على تحديث إعدادات SMTP"
      },
      "ADDRESS": {
        "LABEL": "العنوان",
        "PLACE_HOLDER": "العنوان (على سبيل المثال: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "المنفذ",
        "PLACE_HOLDER": "المنفذ"
      },
      "LOGIN": {
        "LABEL": "تسجيل الدخول",
        "PLACE_HOLDER": "تسجيل الدخول"
      },
      "PASSWORD": {
        "LABEL": "كلمة المرور",
        "PLACE_HOLDER": "كلمة المرور"
      },
      "DOMAIN": {
        "LABEL": "النطاق",
        "PLACE_HOLDER": "الدومين"
      },
      "ENCRYPTION": "التشفير",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "فتح وضع التحقق من SSL",
      "AUTH_MECHANISM": "المصادقة"
    },
    "NOTE": "ملاحظة: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "صورة الموقع",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "الصورة الرمزية حذفت بنجاح",
              "ERROR_MESSAGE": "حدث خطأ، الرجاء المحاولة مرة أخرى"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "اسم الموقع",
          "PLACE_HOLDER": "أدخل اسم موقع الويب الخاص بك (مثال: Acme Inc)",
          "ERROR": "الرجاء إدخال اسم موقع صالح"
        },
        "WELCOME_HEADING": {
          "LABEL": "العنوان الترحيبي",
          "PLACE_HOLDER": "مرحبا بك!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "افتتاحية الترحيب",
          "PLACE_HOLDER": "نحن نجعل من السهل عليك التواصل معنا. اسألنا أي شيء، أو قم بمشاركتنا ملاحظاتك."
        },
        "REPLY_TIME": {
          "LABEL": "وقت الرد",
          "IN_A_FEW_MINUTES": "في غضون دقائق قليلة",
          "IN_A_FEW_HOURS": "في غضون ساعات قليلة",
          "IN_A_DAY": "خلال يوم"
        },
        "WIDGET_COLOR_LABEL": "لون صندوق الدردشة",
        "WIDGET_BUBBLE": "Bubble",
        "WIDGET_BUBBLE_POSITION_LABEL": "Position:",
        "WIDGET_BUBBLE_TYPE_LABEL": "النوع:",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "تحدث الينا",
          "LABEL": "Launcher Title",
          "PLACE_HOLDER": "تحدث الينا"
        },
        "UPDATE": {
          "BUTTON_TEXT": "تحديث إعدادات اللايف شات",
          "API": {
            "SUCCESS_MESSAGE": "تم تحديث إعدادت اللايف شات بنجاح",
            "ERROR_MESSAGE": "غير قادر على تحديث إعدادات اللايف شات"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "معاينة",
          "SCRIPT": "النص"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "يسار",
          "RIGHT": "يمين"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "عادي",
          "EXPANDED_BUBBLE": "ايقونت اللايف شات العرضية"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "افتراضي",
        "CHAT": "Chat mode"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "عادة نقوم بالرد خلال بضع دقائق",
        "IN_A_FEW_HOURS": "عادة نقوم بالرد خلال بضع ساعات",
        "IN_A_DAY": "عادة نقوم بالرد خلال يوم واحد"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "ابدأ المحادثة",
        "CHAT_INPUT_PLACEHOLDER": "أكتب رسالتك"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "متواجدون لخدمتك",
          "OFFLINE": "نحن بعيدون في الوقت الحالي"
        },
        "USER_MESSAGE": "مرحبا",
        "AGENT_MESSAGE": "مرحبا"
      },
      "BRANDING_TEXT": "مدعوم بواسطة Chatwoot",
      "SCRIPT_SETTINGS": "\n      window.chatwootSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": {
        "TITLE": "Microsoft",
        "DESCRIPTION": "Connect with Microsoft"
      },
      "GOOGLE": {
        "TITLE": "Google",
        "DESCRIPTION": "Connect with Google"
      },
      "OTHER_PROVIDERS": {
        "TITLE": "Other Providers",
        "DESCRIPTION": "Connect with Other Providers"
      }
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "الموقع الإلكتروني",
      "TWITTER_PROFILE": "تويتر",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "واتساب",
      "SMS": "SMS",
      "EMAIL": "البريد الإلكتروني",
      "TELEGRAM": "تيليجرام",
      "LINE": "Line",
      "API": "قناة API",
      "INSTAGRAM": "Instagram",
      "TIKTOK": "TikTok",
      "VOICE": "Voice"
    }
  }
}
